
<template>
	<div>
		<vue-draggable-resizable
			class="element-position-lowerthird "
			:style="style"
			:class="className"
			v-if="status === 'preview' && isLottie"
			:draggable="status === 'preview' && !item.is_locked && !content.isPosition"
			:resizable="status === 'preview' && !item.is_locked && !content.isPosition"
			:lock-aspect-ratio="isLockRatio"
			:x="content.x"
			:y="content.y"
			:w="content.width"
			:h="content.height"
			@dragstop="onDragstop"
			@resizestop="onResizestop"
			@dragging="onDrag"
			@resizing="onResize"
			:preventActiveBehavior="true"
			:parent="false">
			<div :id="'preview'+lottieId"
				:width="content.width"
				:height="content.height"
				scrolling="no"
				:src="content.url"
				v-if="isLottie">
			</div>
		</vue-draggable-resizable>
		<div class="element-position"
				:class="className"
				:style="styleLive"
				v-if="status ==='live' && isLottie ">
			<div :id="'live'+lottieId"
				v-if="status ==='live' && isLottie "
				scrolling="no"
				:width="content.width"
				:height="content.height"
				:src="content.url"
				>
			</div>
		</div>
		<!-- @TODO: -->
		<!-- Video Element -->
	</div>
</template>

<script>
/* eslint-disable no-param-reassign */
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import localforage from 'localforage';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ElementLottie',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	data() {
		return {
			// eslint-disable-next-line no-undef
			animax: lottie,
			animationData: null,
			localItem: null,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
			}
		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	methods: {
		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}


			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			} else {
				content.y = y;
			}
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {
		},
		onResize(x, y, width, height) {
			this.content.x = x;
			this.content.y = y;
			this.content.width = width;
			this.content.height = height;
		},
		lottiedatachange(data) {
			const parsedData = duplicateVar(data);
			const assets = parsedData.assets;
			if (assets) {
				for (let i = 0; i < assets.length; i++) {
					if (this.content.assetsURL && this.content.assetsURL[i] && this.content.assetsURL[i].u) parsedData.assets[i].u = this.content.assetsURL[i].u;
					if (this.content.assetsURL && this.content.assetsURL[i] && this.content.assetsURL[i].p) parsedData.assets[i].p = this.content.assetsURL[i].p;
				}
			}
			return parsedData;
		},
		updatelottieparam() {
			this.animax.destroy();
			this.forcePlay();
		},
		stopAll() {
			const callback = () => {
				// const data = response.data;
				// executeCallbackOnce++; // stop next execution
			};
			const errorCallback = () => {
			};

			rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback); // stop the lower third automatically
		},
		async forcePlay() {
			const container = this.status === 'live' ? document.getElementById(`live${this.lottieId}`) : document.getElementById(`preview${this.lottieId}`);
			if (this.content) {
				const url = this.content && this.content.url ? this.content.url : '';
				if (url) {
					this.animationData = null;
					const templateId = this.content && this.content.id ? this.content.id : null;
					const lottieKey = `lottie_media_${templateId}`;
					localforage.getItem(lottieKey).then(async (value) => {
						if (value) {
							this.animationData = value;
						} else {
							this.animationData = await (await fetch(url)).json();
							const data = duplicateVar(this.animationData);
							// eslint-disable-next-line no-unused-vars
							localforage.setItem(lottieKey, data).then(() => {
								// eslint-disable-next-line no-unused-vars
							}).catch((err) => {
								// we got an error
							});
						}

						if (this.animationData) this.animationData = this.lottiedatachange(this.animationData);
						const loop = this.content && this.content.loop ? this.content.loop : false;

						const animcomp = {
							name: 'lottiescene',
							container,
							renderer: 'svg',
							animationData: this.animationData,
							loop,
							prerender: true,
							autoplay: 1,
							useframes: true,
							rendererSettings: {
								filterSize: {
									width: '200%',
									height: '200%',
									x: '-50%',
									y: '-50%',
								},
							},
						};
						// eslint-disable-next-line no-undef
						const lottieAnimax = this.animax.loadAnimation(animcomp);
						let executeCallbackOnce = 1; // to make sure this only run onc
						const interval = setInterval(() => {
							// console.log(lottieAnimax.currentFrame, lottieAnimax.totalFrames);
							if (lottieAnimax.currentFrame === lottieAnimax.totalFrames - 1 && executeCallbackOnce === 1) {
								this.stopAll();
								if (this.status === 'live') {
									if (this.content && this.content.onCompleteItem) {
										this.onCompletePlay(this.content.onCompleteItem);
									}
								}
								clearInterval(interval);
								executeCallbackOnce++;
							}
						}, 100);

						// this.animax.addEventListener('enterFrame', () => {
						// });
						// eslint-disable-next-line no-undef
						// this.animax.play();
						// this.parseLottieData(data, isReset);
					});

					// eslint-disable-next-line no-undef
				}
			}
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	beforeDestroy() {
		// if (this.status === 'live') {
		// 	if (this.content && this.content.onCompleteItem) {
		// 		this.onCompletePlay(this.content.onCompleteItem);
		// 	}
		// }
	},
	mounted() {
		this.forcePlay();
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	watch: {
		item() {
			this.localItem = duplicateVar(this.item);
		},
		content() {
			if (this.content) {
				if (this.status === 'preview' && this.localItem.is_playing_preview) {
					// eslint-disable-next-line no-undef
					this.animax.destroy();
					this.updatelottieparam();
				}
			}
		},
	},
	computed: {
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		lottieId() {
			// if (this.item) {
			// eslint-disable-next-line no-undef
			return `lottie${this.localItem.slug}-${this.localItem.id}`;
			// }
		},
		content() {
			return this.localItem && this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			// if (content.width) style.width = `${content.width}px`;
			// if (content.height) style.height = `${content.height}px`;
			// if (content.y) style.top = `${content.y}px`;
			// if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		isLottie() {
			return this.localItem.type === 'lottie';
		},
		isVideo() {
			return this.content && this.content.type === 'video';
		},
	},
};
</script>
